<!--
 * @Author: maolin lin.mao3@gientech.com
 * @Date: 2024-08-02 15:30:08
 * @Description: 
-->
<template>
  <el-date-picker
    class="lc-date-picker"
    v-model="datePickerValue"
    v-bind="configs"
    clear-icon="el-icon-error"
    :picker-options="pickerOptions"
    @mouseenter.native="handleEnter"
    @mouseleave.native="handleLeave"
  >
  </el-date-picker>
</template>

<script>
export default {
  name: 'LcDatePicker',
  props: {
    configs: {
      type: Object,
      default: () => {}
    },
    value: {
      type: [String, Date],
      default: ''
    }
  },
  data() {
    return {
      datePickerValue: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick: (picker) => {
              picker.$emit('pick', new Date());
            }
          }
        ]
      }
    };
  },
  watch: {
    datePickerValue(val) {
      this.$emit('input', val);
    }
  },
  mounted() {
    this.datePickerValue = this.value;
    this.adjustIconPosition();
  },
  methods: {
    adjustIconPosition() {
      const parentDoms = document.getElementsByClassName('lc-date-picker');
      for (let i = 0; i < parentDoms.length; i++) {
        let dom = parentDoms[i];
        const iconDom = dom?.getElementsByClassName('el-input__prefix')[0];
        iconDom?.setAttribute('class', 'el-input__suffix is-date');
      }
    },
    handleEnter(event) {
      let val = this.datePickerValue;
      const parentDom = event.currentTarget;
      const iconDom = parentDom?.getElementsByClassName('el-input__suffix is-date')[0];
      iconDom?.setAttribute('style', val ? 'display:none' : 'display:block');
    },
    handleLeave(event) {
      const parentDom = event.currentTarget;
      const inputDom = parentDom?.getElementsByClassName('el-input__suffix is-date')[0];
      inputDom?.setAttribute('style', 'border-color: #C0C4CC');
    }
  }
};
</script>

<style lang="scss"></style>
